import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuideArticle from "../pages/article/page";
import QuestCePage from "../pages/seo-questce/page";
import CommentCaFonctionnePage from "../pages/seo-fonctionne/page";
import FonctionnalitesPage from "../pages/seo-fonctionnalites/page";
import TarifsPage from "../pages/seo-tarifs/page";
import SecuritePage from "../pages/seo-securite/page";
import AnalyseConcurrentsPage from "../pages/seo-concurrents/page";
import VsExcelPage from "../pages/seo-vs-excel/page";
import VsNotionPage from "../pages/seo-vs-notion/page";
import TutorielPage from "../pages/seo-tutoriel/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guide-hipobuy-spreadsheet",
    element: <GuideArticle />,
  },
  {
    path: "/quest-ce-que-hipobuy-spreadsheet",
    element: <QuestCePage />,
  },
  {
    path: "/comment-ca-fonctionne-hipobuy-spreadsheet",
    element: <CommentCaFonctionnePage />,
  },
  {
    path: "/fonctionnalites-hipobuy-spreadsheet",
    element: <FonctionnalitesPage />,
  },
  {
    path: "/tarifs-hipobuy-spreadsheet",
    element: <TarifsPage />,
  },
  {
    path: "/securite-confidentialite-hipobuy-spreadsheet",
    element: <SecuritePage />,
  },
  {
    path: "/analyse-concurrents-hipobuy-spreadsheet",
    element: <AnalyseConcurrentsPage />,
  },
  {
    path: "/hipobuy-spreadsheet-vs-excel",
    element: <VsExcelPage />,
  },
  {
    path: "/hipobuy-spreadsheet-vs-notion",
    element: <VsNotionPage />,
  },
  {
    path: "/tutoriel-hipobuy-spreadsheet",
    element: <TutorielPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;